import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { slugs } from "../../../Constant/slugs";
import { AdsGETApiAuth, AdsPUTApi } from "../../../Constant/api";
const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.id,
    sortable: true,
    reorder: true,
  },
  {
    id: 31,
    name: "Title",
    selector: (row) => row.title.rendered,
    sortable: true,
    reorder: true
  },
  // {
  //   id: 3,
  //   name: "Batch Start",
  //   selector: (row) => row.meta.batch_start_date,
  //   sortable: true,
  //   reorder: true
  // },
  {
    id: 32,
    name: "Price",
    selector: (row) => row.meta.price,
    sortable: true,
    reorder: true
  },
  {
    id: 312,
    name: "Click",
    selector: (row) => row.meta.class_link,
    sortable: true,
    reorder: true
  },
  {
    id: 3,
    name: "View",
    right: true,
    cell: (row) => <Link to={`${slugs.course_packages_details}${row.slug}`}>View</Link>,

  }
];

export default function AllChapter() {
  const [Projects1, setProjects1] = React.useState([])
  const [Projects2, setProjects2] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, slugs.db_slug_chapters)
      .then((res) => {
        setProjects2(res.data.filter(a => a.status == "publish"))
        setCustomersList(res.data)
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects({
      per_page: 100,
      _fields: "id,title,slug,meta,status",
      status: "any"
    })

  }, [])

  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Course</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Course
        </div>
      </div>
      <a href={slugs.new_course_package}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
          onClick={() => {

          }}
        >Add New Course</div>
      </a>
      <div style={{ display: "inline", cursor: "pointer" }}>

        <div style={{ display: "inline-block", margin: "0px 5px" }}
          onClick={() => {
            setProjects2(CustomersList.filter(a => a.status == "publish"))
          }}
        >
          Active ({CustomersList.filter(a => a.status == "publish").length}) |
        </div>
        <div style={{ display: "inline-block", margin: "0px 5px" }}
          onClick={() => {
            setProjects2(CustomersList.filter(a => a.status == "draft"))
          }}
        >
          Hidden ({CustomersList.filter(a => a.status == "draft").length}) |
        </div>
        {Projects1.filter(a => a.status == "publish").length !== 0 &&
          <div style={{ display: "inline-block", margin: "0px 5px" }}
            onClick={() => {
              for (let i = 0; i < Projects1.length; i++) {
                setReload(true)
                AdsPUTApi({
                  status: "draft"
                }, slugs.db_slug_chapters, Projects1[i].id)
                  .then(res => {
                    if (i == Projects1.length - 1) {
                      setProjects1([])
                      GetAllProjects({
                        per_page: 100,
                        _fields: "id,title,slug,meta",
                        status: "any"
                      })
                    }
                  })
              }
            }
            }
          >
            Hide |
          </div>
        }
        {Projects1.filter(a => a.status == "draft").length !== 0 &&
          <div style={{ display: "inline-block", margin: "0px 5px" }}
            onClick={() => {
              for (let i = 0; i < Projects1.length; i++) {
                setReload(true)
                AdsPUTApi({
                  status: "publish"
                }, slugs.db_slug_chapters, Projects1[i].id)
                  .then(res => {
                    if (i == Projects1.length - 1) {
                      setProjects1([])
                      GetAllProjects({
                        per_page: 100,
                        _fields: "id,title,slug,meta",
                        status: "any"
                      })
                    }
                  })
              }
            }
            }
          >
            UnHide |
          </div>
        }
      </div>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={Projects2}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          pagination
          selectableRows
          onSelectedRowsChange={(r) => {
            console.log("asdasd", r)
            setProjects1(r.selectedRows)
          }}
        />
      </div>
      {
        Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div >
  )
}